import React, { Component } from "react";
import { Link } from "react-router-dom";
import ApiBitcoin from "../../utils/api.bitcoin";
import ApiProfile from "../../utils/api.profile";
import ShowValue from "../../components/ShowValue";

const LEVEL_TRANSFORM = ["stars", "planets", "moons", "craters", "lots"];

declare var firebase;
declare var FB;
declare var location;

class SubAsset extends Component {
  DEFAULT_OWNER = "Loading owner name...";

  constructor(props) {
    super(props);

    let level = LEVEL_TRANSFORM[props.child.info.level - 1],
      btc_address =
        props.child.info.previous_landers[0].previous_lander_btc_address,
      on_sale = props.child.info.on_sale,
      in_auction = props.child.info.auction,
      property = "not-sale";

    if (in_auction && !on_sale) {
      property = "in-auction";
    }

    if (props.child.info.on_sale) {
      property = "no-owner";
    }

    let profile = localStorage.getItem("userData");
    if (btc_address && btc_address !== "") {
      property = "has-owner";
    }

    if (profile && on_sale && btc_address) {
      profile = JSON.parse(profile);
      property =
        profile.lander_btc_address == btc_address ? "owner" : "has-owner";
    }

    this.state = {
      level: level.charAt(0).toUpperCase() + level.slice(1).replace("s", ""),
      owner: this.DEFAULT_OWNER,
      value: 0.0,
      btc_address: btc_address,
      property: property
    };

    this.shareFB = this.shareFB.bind(this);
    this.hover = this.hover.bind(this);
  }

  hover() {
    if (this.DEFAULT_OWNER !== this.state.owner) return;

    if (this.state.btc_address && this.state.btc_address !== "") {
      new ApiProfile()
        .getByBtcAddress(this.state.btc_address)
        .then(response => {
          let owner = response.data;
          if (owner) {
            let user = firebase.auth().currentUser;
            this.setState(...this.state, {
              owner: owner.name,
              property: user && user.uid === owner.uid ? "owner" : "has-owner"
            });
          }
        });
    } else {
      this.setState(...this.state, { owner: "Cryptolands.io" });
    }
  }

  shareFB() {
    FB.ui(
      {
        method: "share",
        display: "popup",
        quote: `Hey facebook friends, I own an asset at Cryptolands.io! Check this out. The asset name is ${
          this.state.name
        }!`,
        href: location.href
      },
      function(response) {}
    );
  }

  render() {
    return (
      <Link to={this.props.child.assetline}>
        <div onMouseEnter={this.hover} className="asset-container">
          <img
            className={"asset-secondary " + this.state.property}
            alt="child asset"
            style={this.props.child.style}
            src={this.props.child.info.image}
          />

          <div
            className="asset-hover "
            style={{
              left: this.props.child.style.left,
              top: this.props.child.style.top,
              marginLeft: this.props.child.info.size.height
            }}
          >
            <div className="header">
              <h2 className="text-center">
                {this.state.level}: {this.props.child.info.name}
              </h2>
            </div>
            <div className="body">
              <p className="name-owner">
                Owner: <span>{this.state.owner}</span>
              </p>
              <p
                className="message-owner"
                hidden={
                  !this.props.child.info.owner_message ||
                  this.props.child.info.owner_message === ""
                }
              >
                Message: <span>{this.props.child.info.owner_message}</span>
              </p>
              <h3 className="body" hidden={!this.props.child.info.on_sale}>
                <ShowValue
                  btc={
                    this.props.child.info.previous_landers[0]
                      .previous_lander_asset_price
                  }
                />
              </h3>
            </div>{" "}
            {/* Hover */}
            <div className="footer">
              <div className="btn-group" role="group">
                <Link
                  to={this.props.child.assetline}
                  className="btn btn-secondary"
                >
                  <i className="fas fa-link" />
                  See more
                </Link>
                <Link
                  to={this.props.child.assetline + "&buy=true"}
                  className="btn btn-success"
                  hidden={
                    !this.props.child.info.on_sale ||
                    this.state.property === "owner"
                  }
                >
                  Buy now
                </Link>

                <Link
                  to={this.props.child.assetline + "&bid=true"}
                  className="btn btn-warning"
                  hidden={
                    !this.props.child.info.auction ||
                    this.props.child.info.on_sale
                  }
                >
                  Make an Offer
                </Link>
                <button
                  hidden={this.state.property !== "owner"}
                  className="btn btn-primary"
                  onClick={this.shareFB}
                >
                  <i className="fab fa-facebook-f" /> Share
                </button>
              </div>
            </div>{" "}
            {/* footer - two buttons */}
          </div>
        </div>
      </Link>
    );
  }
}

export default SubAsset;



// WEBPACK FOOTER //
// ./src/containers/AssetPage/subasset.js